<template>
    <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Grupo de Responsáveis:"
    id="selectGruposResponsaveis"
    placeholder="Selecione o(s) Grupo(s)"
    :multiple="true"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'
import GroupRepository from '@/shared/http/repositories/configurations/group'

export default {
  name: 'NxSelectResponsavelGrupo',
  mixins: [ useReactiveModelMixin('value') ],
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  created () {
    this.onLoadGroups()
  },
  methods: {
    onLoadGroups () {
      GroupRepository.GetAllActive()
        .then((res) => {
          this.listOptions = res.data.content.filter((x) => x.id != null).map((x) => ({'value': x.id, 'text': x.nameGroup}))
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de Grupos', 'Erro')
          console.error(err)
        })
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectResponsavelGrupo.vue